import React, { useEffect, useMemo, useRef, useState } from 'react';
import createUUID from 'src/utils/random';

export function SwitchGroup(props: {
    children?: JSX.Element[],
    items: SwitchGroupItem[],
    type?: 'horizontal-icon' | 'condensed',
    onSwitched?: (id: string | number) => void,
    onBeforeSwitched?: OnBeforeSelectedHandler,
    defaultItemId?: string | number,
    selectedItemId?: string | number
}) {
    const [firstChild] = props.items;
    const [localSelectedItemId, setSelectedItem] = useState<string | number>(typeof props.defaultItemId !== 'undefined' ? props.defaultItemId : firstChild.id);
    const [cmpId] = useState(createUUID())

    useEffect(() => {
        if (!props.defaultItemId && props.selectedItemId !== localSelectedItemId) {
            setSelectedItem(props.selectedItemId);
        }
    }, [props.selectedItemId, localSelectedItemId]);

    return <div>
        <SwitchGroupHorizontal
            items={props.items}
            selectedItemId={localSelectedItemId}
            onSelected={(id) => { setSelectedItem(id); props.onSwitched && props.onSwitched(id); }}
            onBeforeSelected={props.onBeforeSwitched}
            cmpId={cmpId}
            type={props.type} />

        {props.children && props.children.filter(i => i.props && i.props['id'] == localSelectedItemId)}
    </div>
}

export type SwitchGroupItem = {
    id: string | number;
    text: React.ReactNode;
    iconComponent?: React.ReactNode
}

export type OnBeforeSelectedHandler = (id: string | number, propagationStopper: () => void) => void;

export function SwitchGroupHorizontal(props: {
    items: SwitchGroupItem[],
    onSelected: (id: string | number) => void,
    cmpId?: string,
    selectedItemId: string | number,
    type?: 'horizontal-icon' | 'condensed',
    onBeforeSelected?: OnBeforeSelectedHandler
}) {
    const finalCmpId = useMemo(() => props.cmpId ?? createUUID(), [props.cmpId]);

    return <div className={`switch-group-horizontal ${props.type == 'condensed' ? 'condensed' : ''}`}>
        {props.items.map(i => <SwitchGroupItemCmp key={i.id} {...i} cmpId={finalCmpId} onBeforeSelected={props.onBeforeSelected} onSelected={props.onSelected} selectedItem={props.selectedItemId} type={props.type} />)}
    </div>
}

function SwitchGroupItemCmp(props: SwitchGroupItem & {
    cmpId: string,
    onSelected: (id: string | number) => void,
    onBeforeSelected?: OnBeforeSelectedHandler,
    selectedItem: string | number,
    type?: 'horizontal-icon' | 'condensed'
}) {
    return <label className="switch-item">
        <input type="radio" value={props.id} onClickCapture={(e) => props.onBeforeSelected && props.onBeforeSelected((e.target as HTMLInputElement).value, () => { e.preventDefault(); e.stopPropagation(); })} checked={props.id == props.selectedItem} name={props.cmpId} onChange={() => props.onSelected(props.id)} />
        <span className={`box ${props.iconComponent ? props.type == 'horizontal-icon' ? 'box-with-horizontal-icon' : 'box-with-icon' : 'box-with-text'} ${props.type == 'condensed' ? 'condensed' : ''}`}>
            {props.iconComponent}
            <span className="label">{props.text}</span>
        </span>
    </label>
}

export function SwitchGroupPanel(props: { id: string | number, children: React.ReactNode }) {
    return <>
        {props.children}
    </>
}